export default "__VITE_ASSET__BygwFdx3__"